import { CategoryFilterComponent } from "@/components/CategoryFilters/CategoryFilters.builder";
import { CategoryItemsComponent } from "@/components/CategoryItems/CategoryItems.builder";
import { CategoryNameComponent } from "@/components/CategoryName/CategoryName.builder";
import { AttributeFiltersDrawer } from "@/components/ProductAttributeFiltersDrawer/ProductAttributeFiltersDrawer.builder";
import { RegionSelectorComponent } from "@/components/RegionSelector/RegionSelector.builder";

export const categoryCustomComponents: RegisteredComponent[] = [
  CategoryNameComponent,
  CategoryItemsComponent,
  CategoryFilterComponent,
  RegionSelectorComponent,
  AttributeFiltersDrawer,
];
